module.exports = __webpack_public_path__ + "16903f8ae59b8fa1d5070041165c656e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/bloomberg_2022_chart.png
// module id = 1639
// module chunks = 0